export enum EnumAlertaTipo {
    'Usuário' = 0,
    Conta = 1,
    Administradores = 2,
    'Entidade Pública' = 3,
    Bilhetadora = 4,
    Operadora = 5,
    'Consórcio' = 6,
    Loja = 7,
    Gestor = 8
}
